export type SkyscannerChannelId = 'X-Skyscanner-ChannelId';
export type SkyscannerDeviceDetectionIsMobile = 'X-Skyscanner-DeviceDetection-IsMobile';
export type SkyscannerDeviceDetectionIsTablet = 'X-Skyscanner-DeviceDetection-IsTablet';
export type SkyscannerTravellerContext = 'X-Skyscanner-Traveller-Context';
export type SkyscannerUtid = 'X-Skyscanner-Utid';
export type SkyscannerViewId = 'X-Skyscanner-ViewId';

export type GatewayServedBy = 'x-gateway-servedby';
export const GATEWAY_SERVED_BY: GatewayServedBy = 'x-gateway-servedby';
export const SKYSCANNER_CHANNEL_ID = 'X-Skyscanner-ChannelId';
export const SKYSCANNER_DEVICE_DETECTION_IS_MOBILE = 'X-Skyscanner-DeviceDetection-IsMobile';
export const SKYSCANNER_DEVICE_DETECTION_IS_TABLET = 'X-Skyscanner-DeviceDetection-IsTablet';
export const SKYSCANNER_TRAVELLER_CONTEXT = 'X-Skyscanner-Traveller-Context';
export const SKYSCANNER_UTID = 'X-Skyscanner-Utid';
export const SKYSCANNER_VIEW_ID = 'X-Skyscanner-ViewId';
